export const svgHeight = 125

// 22 for the typography, 20 for extra spacing (10 top + 10 bottom)
export const illustrationHeight: number = svgHeight + 42

export const triggerHeight: number = illustrationHeight + 20
export const maxHeight: number = illustrationHeight * 1.25
